// Service job costing client — labor rates, previews, snapshots, post-job BOM.

import { manufacturingFetch } from "@/lib/manufacturingClient";
import type {
  ServiceCostPreview,
  ServiceJobActualMaterial,
  ServiceJobCostSnapshot,
  ServiceLaborRate,
  ServiceTaggedRecipe,
} from "./types";

type OrgEnvelope = { ok: true; organization_id: string };

export function listServiceLaborRates() {
  return manufacturingFetch<OrgEnvelope & { labor_rates: ServiceLaborRate[] }>(
    "/api/service/labor-rates",
    { method: "GET" }
  );
}

export function upsertServiceLaborRate(payload: {
  id?: string;
  queue_id?: string | null;
  offering_id?: string | null;
  label?: string;
  rate_cents: number;
  rate_kind?: ServiceLaborRate["rate_kind"];
  is_active?: boolean;
}) {
  return manufacturingFetch<OrgEnvelope & { labor_rate: ServiceLaborRate }>(
    "/api/service/labor-rates/upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}

export function getServiceCostPreview(opts: {
  event_id?: string;
  queue_id?: string;
  offering_id?: string;
  mfg_recipe_id?: string | null;
}) {
  const q = new URLSearchParams();
  if (opts.event_id) q.set("event_id", opts.event_id);
  if (opts.queue_id) q.set("queue_id", opts.queue_id);
  if (opts.offering_id) q.set("offering_id", opts.offering_id);
  if (opts.mfg_recipe_id) q.set("mfg_recipe_id", opts.mfg_recipe_id);
  return manufacturingFetch<OrgEnvelope & { preview: ServiceCostPreview }>(
    `/api/service/costing/preview?${q.toString()}`,
    { method: "GET" }
  );
}

export function getServiceCostSnapshot(eventId: string) {
  const q = new URLSearchParams({ event_id: eventId });
  return manufacturingFetch<OrgEnvelope & { snapshot: ServiceJobCostSnapshot | null }>(
    `/api/service/costing/snapshot-get?${q.toString()}`,
    { method: "GET" }
  );
}

export function listServiceTaggedRecipes() {
  return manufacturingFetch<OrgEnvelope & { recipes: ServiceTaggedRecipe[] }>(
    "/api/service/recipes",
    { method: "GET" }
  );
}

export function listServiceJobActualMaterials(eventId: string) {
  const q = new URLSearchParams({ event_id: eventId });
  return manufacturingFetch<OrgEnvelope & { lines: ServiceJobActualMaterial[] }>(
    `/api/service/job-actual-materials?${q.toString()}`,
    { method: "GET" }
  );
}

export function upsertServiceJobActualMaterial(payload: {
  id?: string;
  event_id: string;
  material_id?: string | null;
  label?: string;
  quantity?: number;
  unit_cost_cents?: number | null;
  source?: ServiceJobActualMaterial["source"];
  receipt_ref?: string | null;
  notes?: string;
  delete?: boolean;
}) {
  return manufacturingFetch<
    OrgEnvelope & { line?: ServiceJobActualMaterial; deleted?: boolean }
  >("/api/service/job-actual-materials/upsert", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
